import { render, staticRenderFns } from "./CookieConsent.vue?vue&type=template&id=3634b83b&scoped=true&"
import script from "./CookieConsent.vue?vue&type=script&lang=ts&"
export * from "./CookieConsent.vue?vue&type=script&lang=ts&"
import style0 from "./CookieConsent.vue?vue&type=style&index=0&id=3634b83b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3634b83b",
  null
  
)

export default component.exports